import React, {
  Component
} from 'react';


export default class Decline extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  continueContract(){
    this.props.continueContract();
  }

  declineContract(){
    this.props.declineContract();
  }

  render() {
    return (
     <section className="scroll" id="semana-scroll-inner">
         <section className="viewport">
            <section className="overview">
              <div className="inner-content">
               <div className="rules-regulations">

               <div className="thanksmsg5">
               <h1 className="contractrej">You have chosen to quit this Program!</h1>
        								<p>This means your PIN will be deactivated immediately and any information you have entered during this Program will be lost.</p>
        							</div>
         							<div className="button" >
                <input type="button" name="btnsubmit" value="Continue Learning" alt="Continue Learning" title="Continue Learning" className="button-accept contrarejbtn" onClick={(e)=>this.continueContract()} style={{float:'right'}} />

                <input type="button" onClick={(e)=>this.declineContract()} name="btnsubmit" value="Quit the Program" alt="Quit the Program" title="Quit the Program" className="button-cancel mail-icon" style={{float:'right'}} />
                </div>


              </div>
              </div>
            </section>
          </section>
        </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/contractpartials/Decline.js